// =============================================================================
// Find Your...
// =============================================================================

$('document').ready(() => {

    var logo = ['https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/17152312/twin-shell-mono.svg',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/17152448/airflow-mono.svg',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/17152446/halo-mono.svg',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/17152443/eye-line-grille-mono.svg',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/19125309/Single-Shell-Logo-138px.png'];
    var img = [ 'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/20134220/Vision-Series-Single-Shell.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/20134215/Vision-Series-Airflow1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/20134224/Vision-Series-Halo1.png', 
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2018/12/20134211/Vision-Series-Eyeline1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/02/04075714/OS2-Test-Product-Image-1000px_GHOST.png'];
    var title = ['Twin Shell', 'Airflow', 'Halo Reinforcement System', 'Eye-Line Grille', 'Single Shell Protection System'];
    var zoom = [];
    var txt = ['Double layered shell offering superior strength and durability with twice the protection.',
                'The innovative 3-layer protection system incorporates strategivally placed vents in the inner and outer shalls and air channels throughout the cavity, allowing air to circulate freely at all times, keeping the wearer cool.',
                'Masuri\'s Halo Reinforcement System (HRS) is an extra strength rim featured on every Vision Series model. Made from the latest reinforced plastics, HRS significantly increases protection by ensuring minimal deformation of the helmet shell during impact.',
                'The Eye-Line Grille is an additonal bar, placed on the eye-line which present a greater surface area to the ball on impact. The rear bar forces the ball upwards towards the solid part of the peak and deflects it away form the player\'s face.',
                'Single layered, lightweight construction providing affordable but still durable protection.'];

    if ($('.component--protection_legs').length) {
        logo = ['https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15093523/pro-foams-logo.svg', 
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15093512/knee-blade-logo-copy.svg',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15093509/knee-wing-copy.svg'];
        img = [ 'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28140513/PADS-E-LINE-PRO-FOAMS_Greyed1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28140535/PADS-E-LINE-KNEE-BLADE-Greyed1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28140540/PADS-E-LINE-KNEE-WING-Greyed1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135357/PADS-T-LINE-KNEE-BLADE.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135406/PADS-T-LINE-KNEE-WING.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28205945/PADS-C-LINE-KNEE-BLADE2.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28205955/PADS-C-LINE-KNEE-WING2.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28160631/PADS-T-LINE-PRO-FOAMS1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135307/PADS-C-LINE-PRO-FOAMS.png'
                ];
        zoom = ['https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143114/PADS-E-LINE2.png', 
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143107/PADS-E-LINE-PRO-FOAMS-Greyed1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143056/PADS-E-LINE-KNEE-BLADE-Greyed2.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143101/PADS-E-LINE-KNEE-WING-Greyed2.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143025/PADS-T-LINE1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143121/PADS-T-LINE-KNEE-BLADE1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143019/PADS-T-LINE-KNEE-WING1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143050/PADS-C-LINE1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28205939/PADS-C-LINE-KNEE-BLADE-LRG.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28205950/PADS-C-LINE-KNEE-WING-LRG.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28210000/PADS-T-LINE-PRO-FOAMS-LRG.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28143044/PADS-C-LINE-PRO-FOAMS1.png'
                ];
        title = ['Pro Foam', 'Knee Blade', 'Knee Wing'];
        txt = ['A combination of graded foams that increases impact absorption. Different foam combinations ensure the optimum balance of protection and flexibility in high risk impact areas.',
                    'Reinforced PRO FOAM positioned in front of the traditional knee bolster of a batting pad. Integrated within the pad, reducing the risk of a ball penetrating the knee roll without impacting running movement or comfort.',
                    'Reinforced PRO FOAM that protects the vulnerable side impact zone of the knee joint. Strategically positioned on the front of the pad without having any negative impact on movement or comfort'];

    } else if ($('.component--protection_hands').length) {
        logo = ['https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15093523/pro-foams-logo.svg', 
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15195646/wrist-bar-logo1.svg',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15195642/thumb-claw-logo1.svg', 
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15195650/meta-shield-logo1.svg'];
        img = [ 'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075447/GLOVE-E-LINE-PRO-VIEW-FOAMS1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075455/GLOVE-E-LINE-PRO-VIEW-WRIST-BAR1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075538/GLOVE-E-LINE-PRO-VIEW-CLAW1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075451/GLOVE-E-LINE-PRO-VIEW-META-SHIELD1.png',

                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075506/GLOVE-E-LINE-VIEW-FOAMS1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075513/GLOVE-E-LINE-VIEW-WRIST-BAR1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075502/GLOVE-E-LINE-VIEW-CLAW1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075509/GLOVE-E-LINE-VIEW-META-SHIELD1.png',

                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075529/GLOVE-T-LINE-VIEW-FOAMS1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135136/GLOVES-E-LINE-PRO-WRIST-BAR.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075525/GLOVE-T-LINE-VIEW-CLAW1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075534/GLOVE-T-LINE-VIEW-META-SHIELD1.png',

                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135445/GLOVES-C-LINE-PRO-FOAMS.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135136/GLOVES-E-LINE-PRO-WRIST-BAR.png'];
        zoom = ['https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075424/GLOVE-E-LINE-PRO-VIEW-1.png', 
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075332/GLOVE-E-LINE-PRO-VIEW-FOAMS.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075345/GLOVE-E-LINE-PRO-VIEW-WRIST-BAR.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075326/GLOVE-E-LINE-PRO-VIEW-CLAW.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075338/GLOVE-E-LINE-PRO-VIEW-META-SHIELD.png',

                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075351/GLOVE-E-LINE-VIEW-1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075406/GLOVE-E-LINE-VIEW-FOAMS.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075418/GLOVE-E-LINE-VIEW-WRIST-BAR.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075357/GLOVE-E-LINE-VIEW-CLAW.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075412/GLOVE-E-LINE-VIEW-META-SHIELD.png',

                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075431/GLOVE-T-LINE-VIEW-1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075442/GLOVE-T-LINE-VIEW-FOAMS.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28150431/GLOVES-E-LINE-WRIST-BAR1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075437/GLOVE-T-LINE-VIEW-CLAW.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/04/05075315/GLOVE-T-LINE-VIEW-META-SHIELD.png',
                
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28150332/GLOVES-C-LINE1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28150509/GLOVES-C-LINE-PRO-FOAMS2.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28150431/GLOVES-E-LINE-WRIST-BAR1.png'];
        title = ['Pro Foam', 'Wrist Bar', 'Thumb Claw', 'Meta Shield'];
        txt = ['A combination of graded foams that increases impact absorption. Different foam combinations ensure the optimum balance of protection and flexibility in high risk impact areas.',
                'Reinforced PRO FOAM that protects both the radius and ulna bones in the wrist. Integrated into the existing wrist band of the glove ensuring that playing style is unaffected.',
                    'Reinforced PRO FOAM that hooks around the tip of the thumb offering greater protection when impacted by the ball. Ergonomically designed to fit within the construction of glove without compromising movement or grip on the bat.',
                    'Reinforced PRO FOAM providing targeted and increased protection of the metacarpal knuckle. Integrated within the glove (over the index finger of the bottom hand and little finger in the top hand) without impeding grip.'];

    } else if ($('.component--protection_thigh').length) {
        logo = ['https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15093523/pro-foams-logo.svg'];
        img = [ 'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135429/THIGH-PAD-E-LINE.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/15135436/THIGH-PAD-T-LINE.png'
                ];
        zoom = [ 'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28152913/THIGH-PAD-E-LINE1.png',
                'https://s3-eu-west-2.amazonaws.com/masuri/uploads/2019/03/28152920/THIGH-PAD-T-LINE1.png'
                ];
        title = ['Pro Foam'];
        txt = ['A combination of different grades of foam utilising Masuri’s unique research and development innovations. Different foam compositions ensure the optimum balance of protection and flexibility in high risk impact areas.'];

    } else if ($('.component--protection_personal').length) {

    }

    const toggleProtection = type => {
        return event => {
            event.preventDefault();

            if ( $(event.currentTarget).hasClass('selected')){
                return;
            }

            var url = $(event.currentTarget).attr('href');
            $('.component--protection_series.current').hide().removeClass('current');

            $('#' + url).fadeIn("slow").addClass('current');

            $('.component--protection__selector').removeClass('selected');
            $(event.currentTarget).addClass('selected');
        };
    };

    $('.component--protection__selector').on('click', toggleProtection());



    const showHelmet = type => {
        return event => {
            event.preventDefault();

            var i = $(event.currentTarget).index();
            i++;
            i++;

            var imgs = $(event.currentTarget).closest('.container').find('.component__image');
            var index = $(event.currentTarget).attr('data-target');
            var zoomindex = $(event.currentTarget).attr('data-zoom');
            var zoomdefault = $(event.currentTarget).attr('data-zoom-default');
            var txtinfo = $(event.currentTarget).closest('.container').find('.component__infotext');

            imgs.find('img').css('opacity', 0);

            if ($(event.currentTarget).css('opacity') == 1){
                imgs.find('img:nth-of-type(1)').css('opacity', 1);
                $(event.currentTarget).parent().find('li').css('opacity', 0.5).removeClass('closable');
                txtinfo.html('');
                imgs.find('a').attr('href', zoom[zoomdefault]); 
                return;
            }

            imgs.find('img:nth-of-type(' + i + ')').css('opacity', 1);

            $(event.currentTarget).parent().find('li').css('opacity', 0.5).removeClass('closable');
            $(event.currentTarget).css('opacity', 1).addClass('closable');
            imgs.find('a').attr('href', zoom[zoomindex]); 

            // need to update the text below the logos here as well.
            txtinfo.html('<strong>' + title[index] + '</strong>' + txt[index]);

        };
    };

    $('.component--protection__features li').on('click', showHelmet());



    const helmetModal = type => {
        return event => {
            event.preventDefault();

            var index = $(event.currentTarget).attr('data-target');
            var index_img = $(event.currentTarget).attr('data-image');
            var modal = $('.component--protection__modal');
            modal.find('img:first-of-type').attr('src', logo[index]);
            modal.find('img:last-of-type').attr('src', img[index_img]);
            modal.find('.component--protection__modal__infotext').html('<strong>' + title[index] + '</strong>' + txt[index]);
            modal.show('fast');
        };
    };

    $('.component__image--clicker').on('click', helmetModal());

    const closeHelmetModal = type => {
        return event => {
            event.preventDefault();

            $(event.currentTarget).hide('fast');
        };
    };

    $('.component--protection__modal').on('click', closeHelmetModal());

    const nextHelmet = type => {
        return event => {
            event.preventDefault();

            var listItems = $(event.currentTarget).parent().find('li');
            var n = listItems.length;
            n--;
            listItems.each(function(idx, li) {
                if ($(li).css('opacity') == 1){
                    $(li).css('opacity', 0);
                    if (idx < n) {
                        idx++;
                        listItems.eq(idx).css('opacity', 1);
                    } else {
                        listItems.eq(0).css('opacity', 1);
                    }
                    return;
                };

                // and the rest of your code
            });
        };
    };

    $('.component--protection__helmets .after').on('click', nextHelmet());

    const prevHelmet = type => {
        return event => {
            event.preventDefault();

            var listItems = $(event.currentTarget).parent().find('li');
            var n = listItems.length;
            n--;
            listItems.each(function(idx, li) {
                if ($(li).css('opacity') == 1){
                    $(li).css('opacity', 0);
                    if (idx > 0) {
                        idx--;
                        listItems.eq(idx).css('opacity', 1);
                    } else {
                        listItems.eq(n).css('opacity', 1);
                    }
                    return;
                };

                // and the rest of your code
            });
        };
    };

    $('.component--protection__helmets .before').on('click', prevHelmet());


    var scrollbarwidth = $('.container.compare .scrollbar').width() - 55;
    var scrollwidth = $('.container.compare .component--protection__compare').width() - ($(window).width());

    $('.container.compare .scrollable').on({
        'scroll': function() {
            var sp = $('.container.compare .scrollable').scrollLeft();
            $('.container.compare .scrollbar span').css('width', 35 + (sp / scrollwidth) * scrollbarwidth );
            console.log(scrollbarwidth);
        }
    });

});


// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/Protection.js